const baseUrl = 'https://client.setupad.com/terms_and_conditions/';

const getTermsAndConditionsFileUrl = auth => {
  if (!auth) return null;

  const payer = (auth?.billingDataCheck?.payer ?? 'lv').toLowerCase();
  const type = auth?.type;

  const filenameMap = {
    0: 'adapter',
    5: 'selfserve',
    6: 'selfserve_business',
    7: 'selfserve_enterprise',
  };

  const filename = filenameMap[type] ?? 'wrapper';

  return `${baseUrl}${payer}/${filename}.pdf`;
};

export default getTermsAndConditionsFileUrl;
